export default {
  id: 174,
  title: "Target #174 - Witch's Hat",
  url: 'https://cssbattle.dev/play/174',
  colors: ['#F4DCBF', '#30383F', '#556D7F', '#FBD038'],
  solution:
    '<a a><a b><a c><style>body{background:#f4dcbf}a{position:fixed}a[a]{top:50;left:155;width:90;height:153;clip-path:polygon(0 100%,50% 0,100% 100%);background:#30383f}a[b]{top:190;left:125;width:150;height:60;border-radius:100%;background:radial-gradient(ellipse 150px 60px at top,#30383f 43%,#556d7f 43% 57%,#30383f 57%)}a[c]{top:210;left:185;width:30;height:20;border-radius:5px;background:#fbd038}</style>',
}
